import React, {useState, useEffect} from 'react'
import Button from '@material-ui/core/Button'

import DefaultModal from './defaultModal'
import FileUploader from '../../../../shared/form/fileUploader'
import getApiUrl from '../../../../../lib/getApiUrl'
import { getToken } from '../../../../../lib/auth'

export default function Logo(props) {
    const [defaultOpen, setDefaultOpen] = useState(false)
    const [imgDate, setImgDate] = useState(new Date())
    const [fileID, setFileID] = useState(0)
    const [fileSet, setFileSet] = useState(false)

    useEffect(() => {
        fetch(getApiUrl() + "/file/noCache/logo", {method: "GET", headers: {"x-access-token": getToken()}})
        .then(r => {
            //did we get a file?
            if(r.status === 200) {
                setFileSet(true)
            } else {
                setFileSet(false)
            }
        })
    }, [
        imgDate
    ])

    const handleChange = function() {
        setDefaultOpen(false)
        setImgDate(new Date())
    }

    return(
        <div>
            <h1>
                Logo Image
            </h1>
            <p>
                Here you can upload a logo image into your system.  It appears in the top left corner of your system.  If this is too large it could slow down the loading of your system!
            </p>
            <p>
                <strong>
                    For best results the image should be 130px wide by 48px high, with a transparent background!
                </strong>
            </p>
            {
                fileSet ?
                    <img 
                        src={getApiUrl() + "/file/noCache/logo"}
                        style={{
                            maxWidth: "150px",
                            margin: "10px"
                        }}
                        key={imgDate}
                    />   
                :
                    <><em>(No logo set)</em><br/></>
                    
            }
            <br/>
            <div style={{maxWidth: "400px"}}>
                <FileUploader 
                    onChange={() => setImgDate(new Date())} 
                    value={fileID}
                    id="fileID"
                    disabled={false}
                    //error={props.validationResult.failMessages.hasOwnProperty("fileID")}
                    //helperText={props.validationResult.failMessages["fileID"]}
                    library="logo"
                    label="a new logo (.png, .jpg, .jpeg)"
                    accept="any"
                    urlType="image"
                />
            </div>
            <Button
                onClick={() => setDefaultOpen(true)}
                variant="contained"
                color="default"
                style={{margin: "10px"}}
            >
                Reset
            </Button>
            <DefaultModal
                open={defaultOpen}
                onChange={handleChange}
            />
        </div>
    )
}